<template>
	<div class="container">
		<div class="list" v-for="(val,key) in team" :key='key'>
			<el-image :src="val.image" fit="fill"></el-image>
			<div class="info">
				<div class="title" v-if="$i18n.locale == 'zh'">{{val.name}}</div>
				<div class="title" v-else-if="$i18n.locale == 'en'">{{val.y_name}}</div>
				<div class="title" v-else>{{val.e_name}}</div>

				<div class="text" v-if="$i18n.locale == 'zh'">
					{{val.job}}
				</div>
				<div class="text" v-else-if="$i18n.locale == 'en'">
					{{val.y_job}}
				</div>
				<div class="text" v-else>
					{{val.e_job}}
				</div>

				<p v-if="$i18n.locale == 'zh'">{{val.desc}}</p>
				<p v-else-if="$i18n.locale == 'en'">{{val.y_desc}}</p>
				<p v-else>{{val.e_desc}}</p>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				team:[],
			}
		},
		mounted() {
			this.getabout()
		},
		methods: {
			getabout() {
				var that = this;
				this.$axios
					.post("/api/index/team", {
					})
					.then(function (ret) {
						if (ret.data.code == 0) {
							that.team = ret.data.data.team;
						} else {
							that.$fail(ret.data.msg);
						}
					}
				);
			},
		}
	}
</script>

<style lang="scss" scoped>
	.container {
		width: 900px;
		display: flex;
		flex-direction: column;

		.list {
			width: 900px;
			display: flex;
			align-items: flex-start;
			justify-content: space-between;
			margin-bottom: 50px;
			.el-image {
				width: 220px;
				height: 294px;
			}
			.info{
				display: flex;
				flex-direction: column;
				width: 640px;
				.title{
					font-size: 24px;
					font-weight: bold;
					color: #004098;
					margin-bottom: 15px;
				}
				.text{
					font-size: 18px;
					font-weight: bold;
					color: #004098;
					margin-bottom: 30px;
				}
				p{
					font-size: 16px;
					line-height: 30px;
					color: #333333;
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/AboutUs/expert.vue